export function sortObjAlphabetically(objs, sortKey) {
  objs.sort((a, b) =>
    a[sortKey] > b[sortKey] ? 1 : a[sortKey] < b[sortKey] ? -1 : 0
  );
  return objs;
}

// custom sort method for awards, it does not consider the bracket content.
export function sortAwardObjAlphabetically(objs, sortKey) {
  objs.sort((a, b) => {
    const sortKeyA = removeBrackets(a[sortKey]);
    const sortKeyB = removeBrackets(b[sortKey]);
    return sortKeyA > sortKeyB ? 1 : sortKeyA < sortKeyB ? -1 : 0;
  });
  return objs;
}

// remove brackets, its content, and excess whitespace before and after.
function removeBrackets(input) {
  return input.replace(/\s*\[.*?\]\s*/g, '');
}

export function sortObjAlphabeticallyIgnoringCase(objs, key) {
  return objs.sort((a, b) =>
    a[key].toLowerCase().localeCompare(b[key].toLowerCase())
  );
}

export function sortArrayAsc(array) {
  return array.sort((a, b) => (a ?? 0) - (b ?? 0));
}

export function sortClassification(classifications) {
  if (classifications.length === 0) {
    return [];
  }
  return classifications.sort((a, b) => {
    const aNum = Number(a.BaseRate);
    const bNum = Number(b.BaseRate);
    const aIsValid = !isNaN(aNum);
    const bIsValid = !isNaN(bNum);
    if (aIsValid && bIsValid) {
      if (aNum === bNum) {
        return 0;
      }
      return aNum > bNum ? 1 : -1;
    } else if (!aIsValid && !bIsValid) {
      return 0;
    } else if (!aIsValid) {
      return 1;
    } else {
      return -1;
    }
  });
}
